module.exports = __webpack_public_path__ + "static/media/sg9tj658.e67ad1ee.png";